export const date = node => {
  const addLeadingZero = val => {
    if (val < 10) {
      return `0${val}`;
    }
    return val;
  };
  const result = new Date(Number(node.attrs.timestamp));
  return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};